export default function minTranslate() {
  return -this.snapGrid[0];
}


//////////////////
// WEBPACK FOOTER
// ./~/swiper/esm/components/core/translate/minTranslate.js
// module id = 1192
// module chunks = 168